'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = exports.Field = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.computedField = computedField;
exports.default = computedForm;

var _cerebral = require('cerebral');

var _runValidation = require('./utils/runValidation');

var _runValidation2 = _interopRequireDefault(_runValidation);

var _formToJSON = require('./helpers/formToJSON');

var _formToJSON2 = _interopRequireDefault(_formToJSON);

var _getInvalidFormFields = require('./helpers/getInvalidFormFields');

var _getInvalidFormFields2 = _interopRequireDefault(_getInvalidFormFields);

var _getFormFields = require('./helpers/getFormFields');

var _getFormFields2 = _interopRequireDefault(_getFormFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createFields(form) {
  return Object.keys(form).reduce(function (fields, key) {
    if (form[key] === Object(form[key])) {
      if ('value' in form[key]) {
        fields[key] = new Field(form[key], form);
      } else {
        fields[key] = createFields(form[key], form);
      }
    } else {
      fields[key] = form[key];
    }

    return fields;
  }, {});
}

var Field = exports.Field = function () {
  function Field(field) {
    _classCallCheck(this, Field);

    Object.assign(this, field, {
      isPristine: typeof field.isPristine === 'undefined' ? true : field.isPristine
    });
  }

  _createClass(Field, [{
    key: '_validate',
    value: function _validate(get) {
      return Object.assign(this, (0, _runValidation2.default)(this, get)).isValid;
    }
  }]);

  return Field;
}();

var Form = exports.Form = function () {
  function Form(form, get) {
    _classCallCheck(this, Form);

    Object.assign(this, createFields(form));
    this.isValid = this._validate(get);
  }

  _createClass(Form, [{
    key: '_validate',
    value: function _validate(get) {
      function validate(obj) {
        return Object.keys(obj).reduce(function (isValid, field) {
          if (obj[field] instanceof Field) {
            var isFieldValid = obj[field]._validate(get);

            return isValid ? isFieldValid : false;
          } else if (obj[field] === Object(obj[field])) {
            var areFieldsValid = validate(obj[field]);

            return isValid ? areFieldsValid : false;
          } else {
            return isValid;
          }
        }, true);
      }

      return validate(this);
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return (0, _formToJSON2.default)(this);
    }
  }, {
    key: 'getInvalidFields',
    value: function getInvalidFields() {
      return (0, _getInvalidFormFields2.default)(this);
    }
  }, {
    key: 'getFields',
    value: function getFields() {
      return (0, _getFormFields2.default)(this);
    }
  }]);

  return Form;
}();

function computedField(fieldValueTag) {
  return (0, _cerebral.Compute)(fieldValueTag, function (fieldValue, get) {
    if (!fieldValue || (typeof fieldValue === 'undefined' ? 'undefined' : _typeof(fieldValue)) !== 'object') {
      console.warn('Cerebral Forms - Field value: ' + fieldValueTag + ' did not resolve to an object');
      return {};
    }
    var field = new Field(fieldValue);
    field._validate(get);
    return field;
  });
}

function computedForm(formValueTag) {
  return (0, _cerebral.Compute)(formValueTag, function (formValue, get) {
    if (!formValue || (typeof formValue === 'undefined' ? 'undefined' : _typeof(formValue)) !== 'object') {
      console.warn('Cerebral Forms - Form value: ' + formValueTag + ' did not resolve to an object');
      return {};
    }

    return new Form(formValue, get);
  });
}
//# sourceMappingURL=form.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/forms/lib/form.js
// module id = 302
// module chunks = 5